import React, { useMemo } from "react";
import ReactDOM from "react-dom";

import styles from "./MobileMenu.module.scss";

const MobileMenu = ({ children, className }) => {
  const root = useMemo(() => document.getElementById('menu-root'), []);

  return !!root ? (
    ReactDOM.createPortal(
      <div className={styles.MobileMenu}>
        <div className={className}>
          {children}
        </div>
      </div>,
      root
    )
  ) : (
    <></>
  );
}

export default MobileMenu;
